// Event info — single source of truth
// Update date/location here once to update across the whole site

export const EVENT = {
  dateDisplay: 'May 20–23, 2027',
  location: 'Hemet, California',
  shortLocation: 'Hemet, CA',
  // Where the ministry is based — footer contact info, not the camp location
  hqLocation: 'Long Beach, California',
  // Flip to true when the 2027 WeTravel trip is live; that switches every
  // "Register Soon" button back into a working Register link.
  // Opened 09.30.2026 for Band of Brothers. Points at the West Coast Ministries
  // WeTravel page until Terri sends the direct 2027 trip link.
  registrationOpen: true,
  registerUrl: 'https://www.wetravel.com/trips/west-coast-marriage-camp-west-coast-ministries-5104053372',
  donateUrl: 'https://www.zeffy.com/en-US/donation-form/west-coast-marriage-camp-donation',
  phone: '(626) 536-2034',
  phoneTel: '6265362034',
  email: 'westcoastmarriagecamp@gmail.com',
};
